// The spending categories a receipt line item can belong to. The database
// stores them as free text, so anything read from it must be normalised before
// it reaches components that switch on these five values.
export const RECEIPT_CATEGORIES = ['food', 'household', 'health', 'personal', 'other'] as const;

export type ReceiptCategory = (typeof RECEIPT_CATEGORIES)[number];

/** Case-insensitive; missing or unrecognised values become 'other'. */
export function normalizeCategory(value: string | null | undefined): ReceiptCategory {
  if (!value) return 'other';
  const lower = value.toLowerCase();
  return (RECEIPT_CATEGORIES as readonly string[]).includes(lower) ? (lower as ReceiptCategory) : 'other';
}
